import React from 'react';
import { TrustBar } from './TrustBar';
import { ShowerStyles } from './ShowerStyles';
import { Comparison } from './Comparison';
import { DesignOptions } from './DesignOptions';
import { Quality } from './Quality';
import { Checklist } from './Checklist';
import { Process } from './Process';
import { Benefits } from './Benefits';
import { Audiences } from './Audiences';
import { RelatedServices } from './RelatedServices';
import { WhyChoose } from './WhyChoose';
import { Locations } from './Locations';
import { ShowerDoorsFAQ } from '../../components/ShowerDoorsFAQ/ShowerDoorsFAQ';
import { ServiceReview } from '../../../components/PageIntro';
export function ShowerDoors() {
  return <div className="legacy-sections" data-id="element-1493" data-mp="31iapleexfsfi">
<TrustBar data-id="element-1494" data-mp="31ika4mh7d7dt" />
<ShowerStyles data-id="element-1495" data-mp="31gzcgnzld8bq" />
<ServiceReview index={3} data-id="element-1496" data-mp="31hsitnun1vtc" />
<Comparison data-id="element-1497" data-mp="31k51624b686x" />
<DesignOptions data-id="element-1498" data-mp="36hncfz5sszi3" />
<Quality data-id="element-1499" data-mp="36i6julxto5hv" />
<Checklist data-id="element-1500" data-mp="36igc6g6caoqq" />
<Process data-id="element-1501" data-mp="36iomq1ezphyr" />
<Benefits data-id="element-1502" data-mp="36iydhr7uzt5i" />
<Audiences data-id="element-1503" data-mp="36falwxlz5gtf" />
<RelatedServices data-id="element-1504" data-mp="36fke8ruhs02a" />
<WhyChoose data-id="element-1505" data-mp="3bg8dg0svjn7l" />
<Locations data-id="element-1506" data-mp="3bfyjk24pkvwm" />
<ShowerDoorsFAQ data-id="element-1507" data-mp="3bhjie3y2310a" />
</div>;
}